import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

/**
 * Fetches the list of pending approval person invoices
 * @returns {Promise} - API response containing list of invoices
 */
export const getApprovalPersonInvoices = async () => {
  try {
    const response = await apiClient.get('/approvalPersonInvoiceManagement/invoice/list');

    // Handle the response structure: { status, message, response } or direct array
    if (response.data?.response && Array.isArray(response.data.response)) {
      return response.data.response;
    }

    // Fallback to direct data if structure is different
    return response.data?.response || response.data || [];
  } catch (error) {
    handleApiError(error);
    return [];
  }
};
